"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalDocumentsService = void 0;
class LegalDocumentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1LegalLegalDocuments() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/legal/legalDocuments',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1LegalDocuments({ locale, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/legal/documents',
            query: {
                locale: locale,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.LegalDocumentsService = LegalDocumentsService;
